import { UiIconButtonComponent } from '@/ui/icon-button/ui-icon-button';
import { type IconName, UiIconComponent } from '@/ui/icon/ui-icon';
import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, contentChild, contentChildren, input } from '@angular/core';
import { MatError, MatFormField, MatHint, MatLabel, MatSuffix } from '@angular/material/form-field';
import { AdvizeoTooltipDirective } from '../../../directives/advizeo-tooltip/advizeo-tooltip.directive';
import { UiFormErrorComponent } from '../form-error/ui-form-error';
import { UiFormHintComponent } from '../form-hint/ui-form-hint';
import { UiFormFieldControl, UiFormFieldControlToMatFormFieldControlDirective } from '../ui-form-field-control.class';
@Component({
    styleUrls: ['./ui-form-field.scss'],
    selector: 'ui-form-field',
    templateUrl: 'ui-form-field.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MatFormField,
        MatLabel,
        MatSuffix,
        UiIconButtonComponent,
        UiIconComponent,
        AdvizeoTooltipDirective,
        MatError,
        NgTemplateOutlet,
        MatHint,
        UiFormFieldControlToMatFormFieldControlDirective
    ]
})
export class UiFormFieldComponent {
    label = input<string>();
    hint = input<string>();
    hintType = input<'info' | 'warning'>('info');
    iconName = input<IconName>();
    suffixString = input<string>();

    control = contentChild.required(UiFormFieldControl);
    errorsComponents = contentChildren(UiFormErrorComponent);
    hintsComponents = contentChildren(UiFormHintComponent);

    displayedErrors = computed(() => {
        const controlErrors = this.control().errors();
        return this.errorsComponents().filter(
            errorComponent => !errorComponent.errorCode() || controlErrors.find(({ kind }) => kind === errorComponent.errorCode())
        );
    });

    clear(event: MouseEvent) {
        event.stopPropagation();
        event.preventDefault();
        this.control()?.onClearRequest();
    }
}
